import {Campaign, CampaignsFilter, CampaignUserStatus, SortOptions} from "shared-lib";
import {patchState, signalStore, watchState, withHooks, withMethods, withState} from '@ngrx/signals';
import {CampaignService} from "../services/campaign.service";
import {inject} from "@angular/core";
import {CampaignsFilterStore} from './campaigns-filter.store';
import {Observable} from "rxjs";
import {Page} from '../../../../shared-lib/src/lib/services/model';

interface CampaignsState {
  campaigns: Campaign[];
  isLoading: boolean;
  page: number;
  hasMorePages: boolean;
  status: CampaignUserStatus;
  filter: CampaignsFilter;
}

const initialState = {
  campaigns: [],
  isLoading: false,
  page: 0,
  hasMorePages: true,
  filter: {
    sort: SortOptions.MOST_RECENT,
  } as CampaignsFilter
};

type CampaignsFetcher = (
  service: CampaignService,
  params: { page: number; size: number },
  filter: CampaignsFilter
) => Observable<Page<Campaign>>;

function createCampaignsStore(status: CampaignUserStatus, fetcher: CampaignsFetcher) {
  return signalStore(
    {providedIn: 'root'},
    withState({...initialState, status} as CampaignsState),
    withMethods((store, campaignService = inject(CampaignService)) => ({
      nextPage() {
        patchState(store, {isLoading: true});

        fetcher(campaignService, {
          page: store.page(),
          size: 5
        }, store.filter()).subscribe(page => {
          patchState(store, {
            campaigns: [...store.campaigns(), ...page.content],
            isLoading: false,
            page: store.page() + 1,
            hasMorePages: store.page() < page.page.totalPages - 1
          });
        })
      },
      loadLocations(campaignId: string) {
        const campaign = store.campaigns().find(campaign => campaign.id === campaignId);

        if (!campaign || campaign.locationsGroup) {
          return;
        }

        campaignService.getLocationsForCampaign(campaignId)
          .subscribe(locations => {
            const campaignIndex = store.campaigns().indexOf(campaign);
            const newCampaigns = [...store.campaigns()];
            newCampaigns[campaignIndex] = {
              ...newCampaigns[campaignIndex], locationsGroup: {
                locations,
                reusable: false,
                name: ""
              }
            };

            patchState(store, {
              campaigns: newCampaigns,
              isLoading: store.isLoading(),
              page: store.page(),
              hasMorePages: store.hasMorePages(),
            })
          })
      }
    })),
    withHooks({
      onInit(store, filterStore = inject(CampaignsFilterStore)) {
        watchState(filterStore, (state) => {
          const filterValue = state.filter;

          if (filterValue === store.filter()) {
            return;
          }

          patchState(store, {filter: filterValue, page: 0, hasMorePages: true, campaigns: []});
          store.nextPage();
        });
      }
    })
  );
}

export const CampaignsWithLoyaltyStore = createCampaignsStore(
  CampaignUserStatus.ACTIVE,
  (service, params, filter) => service.getAllWithLoyaltyInRadius(params, filter)
);

export const CampaignsWithoutLoyaltyStore = createCampaignsStore(
  CampaignUserStatus.ACTIVE,
  (service, params, filter) => service.getAllWithoutLoyaltyInRadius(params, filter)
);

export type LoyaltyCampaignsStore = InstanceType<typeof CampaignsWithLoyaltyStore> | InstanceType<typeof CampaignsWithoutLoyaltyStore>;

